import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[glxyComposerActionButton]',
  standalone: false,
})
export class ChatComposerActionButtonDirective {
  @HostBinding('class') class = 'glxy-composer-action-button';
}
